import React, { forwardRef } from 'react';

import cx from 'clsx';

import { SelectOption } from '../../../types';
import { Radio, RadioProps } from '../Radio';

export type RadioGroupProps = RadioProps & {
  name: string;
  options: SelectOption[];
};

/**
 * Creates a radio group with a single choice possible
 */
export const RadioGroup = forwardRef<HTMLInputElement, RadioGroupProps>(
  ({ options, name, className, onChange, ...radioProps }, ref) => {
    return (
      <div className={cx(className, 'd-flex flex-column')} data-testid="radio-group-component">
        {options.map(({ label, value }, idx) => (
          <Radio
            key={idx}
            {...radioProps}
            id={`${name}${idx}`}
            name={name}
            value={value}
            checked={value === radioProps.value}
            ref={ref}
            className="my-1"
            onChange={(newValue, e) => {
              if (value === newValue && onChange) onChange(newValue, e);
            }}
          >
            {label}
          </Radio>
        ))}
      </div>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';
